<template>
  <van-popup v-model="show" round position="bottom" :style="{ height: '40%' }" @close="handleChange">
    <div class="title">图形验证码</div>
    <div class="graph-input flex-row flex-cross-axis-center flex-between">
      <div class="input-bar">
        <input type='text' placeholder="请输入图形验证码" v-model='input' maxlength='8' @blur="onblur" />
      </div>
      <div class="img-bar" @click='getGraphCode'>
        <img :src="image" alt='' />
      </div>
    </div>
    <div class="divider"></div>
    <div class='warning'>{{showWarning}}</div>
    <button @click='submit'>确定</button>
  </van-popup>
</template>

<script>
  import { httpUser } from '../scripts/network'
  import Vue from 'vue';
  import { Popup } from 'vant';

  Vue.use(Popup);
  export default {
    data() {
      return {
        show: this.shows,
        image: null,
        input: null,
        showWarning: '',
      }
    },
    watch: {
      value(val) {
        this.show = val;
        this.getGraphCode();
      }
    },
    props: {
      phone: String,
      value: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      async getGraphCode() {
        this.showWarning = ''
        if (this.phone) {
          this.cancelValidate && this.cancelValidate();
          const params = { param: { "para.tag": this.phone, "para.width": 120, "para.height": 45 } };
          let ret;
          try {
            ret = await httpUser('/User/GetImgValidCode', params, (cancel) => {
              this.cancelValidate = cancel;
            })
          } catch (error) {
            console.error('----', error)
          }
          if (ret && ret.Status) {
            this.image = ret.Data;
          }
        }
      },
      async getSmsCode(code) {
        const body = { 'Mobile': this.phone, 'ValidateCode': code }
        let ret;
        try {
          ret = await httpUser('/User/SendSmsCode', { type: 'post', body: body })
        } catch (error) {
          console.error('error')
          return
        }
        if (ret && ret.Status) {
          this.$toast('短信发送成功');
          setTimeout(() => {
            this.$emit('callback', { success: true, dialog: false });
          }, 500);
        } else {
          this.getGraphCode(true);
          this.showWarning = ret.Message;
        }
      },
      submit() {
        if (!this.input) {
          this.$toast('输入不能为空');
          return
        }
        this.getSmsCode(this.input)
      },
      hideDialog() {

      },
      onblur() {
        window.scrollTo(0, 0);
      },
      handleChange(value) {
        this.$emit('callback', { success: false, dialog: value });
      },
    },

  }
</script>

<style scoped>
  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
  }

  .van-popup {
    padding: 50px 30px 0;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
  }

  .title {
    font-size: 13px;
  }

  .graph-input {
    box-sizing: border-box;
    margin: 3px 0 7px;
  }

  .input-bar {
    flex: 1;

  }

  .graph-input input {
    width: 100%;
    border: none;
    font-size: 18px;
    font-weight: 400;
    color: black;
    letter-spacing: 2px;
    padding: 4px 0;
  }

  .img-bar {
    box-sizing: border-box;
    position: relative;
    width: 110px;
    height: 39px;
    line-height: 39px;
    background-color: #f5f5f5;
  }

  .graph-input img {
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 0;
    height: 100%;
    object-fit: contain;
    transform: translateX(-50%);
  }

  .warning {
    height: 14px;
    line-height: 14px;
    font-size: 11px;
    font-weight: 400;
    color: rgba(234, 76, 76, 1);
    margin: 3px 0 30px;
  }


  button {
    font-size: 16px;
    height: 44px;
    line-height: 46px;
    background: linear-gradient(90deg, rgba(255, 156, 40, 1), rgba(255, 118, 64, 1));
    border-radius: 23px;
    border: none;
    width: 100%;
    color: white;
  }

  button:active {
    background-image: linear-gradient(to right, #fc8c0d, #fc6124);
  }

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    letter-spacing: 0;
  }
</style>